import { FormCondition, Condition } from '@urbanx/agx.campaigns.client';
import { AgxButton } from '@urbanx/agx.ui-components2';
import { useCallback, useEffect, useState } from 'react';
import { NewFormConditionModal } from './NewFormConditionModal';

interface AddBodyCorporateRecordsProps {
  id: string;
  onConfirm: (bodyCorporateRecords: FormCondition) => void;
}

export function AddBodyCorporateRecords({ id, onConfirm }: AddBodyCorporateRecordsProps) {
  const [validate, setValidate] = useState(false);
  const [showAddBodyCorporateRecordsModal, setShowAddBodyCorporateRecordsModal] = useState(false);
  const [bodyCorporateRecordsCondition, setBodyCorporateRecordsCondition] = useState<
    FormCondition | undefined
  >(undefined);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

  useEffect(() => {
    setValidate(false);
  }, [bodyCorporateRecordsCondition]);

  useEffect(() => {
    setErrorMessage(undefined);
    setBodyCorporateRecordsCondition(undefined);
  }, [showAddBodyCorporateRecordsModal]);

  const handleConfirmClick = useCallback(() => {
    setValidate(true);
    if (!bodyCorporateRecordsCondition || !bodyCorporateRecordsCondition.condition) {
      setErrorMessage('Select a condition');
      return;
    } else if (
      bodyCorporateRecordsCondition.condition === Condition.OnSpecificDate &&
      !bodyCorporateRecordsCondition.referenceDate
    ) {
      setErrorMessage('Select a date');
      return;
    } else if (
      bodyCorporateRecordsCondition.condition === Condition.NdaysFromDate &&
      !bodyCorporateRecordsCondition.daysFromDate
    ) {
      setErrorMessage('Enter number of days');
      return;
    } else if (
      bodyCorporateRecordsCondition.condition === Condition.UponSatisfactionOfSpecialCondition &&
      !bodyCorporateRecordsCondition.specialConditionId
    ) {
      setErrorMessage('Enter special condition clause');
      return;
    }

    onConfirm(bodyCorporateRecordsCondition);
    setShowAddBodyCorporateRecordsModal(false);
  }, [bodyCorporateRecordsCondition, onConfirm]);

  return (
    <>
      <AgxButton
        id="add-body-corporate-records"
        variant="hollow"
        text="Add Body Corporate Records"
        onClick={() => setShowAddBodyCorporateRecordsModal(true)}
      />
      {showAddBodyCorporateRecordsModal && (
        <NewFormConditionModal
          id={id}
          modalTitle="Add Body Corporate Records"
          formCondition={bodyCorporateRecordsCondition}
          onDateConditions={[Condition.OnSpecificDate]}
          fromDateConditions={[Condition.NdaysFromDate]}
          errorMessage={errorMessage}
          setFormCondition={setBodyCorporateRecordsCondition}
          onConfirmClick={handleConfirmClick}
          openModal={setShowAddBodyCorporateRecordsModal}
          validate={validate}
        />
      )}
    </>
  );
}
